
import { CvHeader, CvHeaderName } from '@carbon/vue';
import ArrowLeft16 from '@carbon/icons-vue/es/arrow--left/16';
import Vue from 'vue';

export default Vue.extend({
  components: {
    CvHeader,
    CvHeaderName,
    ArrowLeft16,
  },
});
